module.exports = __webpack_public_path__ + "/static/assets/582b9f12ce60392a8ef736c5dfabb4ce.svg";